<template>
  <footer class="footer">
    <div v-if="nationPath === 'kr'" class="companyInfo">
      <a class="accordionBtn" @click="toggleAccordion">
        <span class="accordionTitle">
          {{ $t('footer.nexon_korea_business_info_A05') }}
        </span>
        <i class="icon" :class="open ? 'iconUp2' : 'iconDown2'"></i>
      </a>

      <transition name="accordion">
        <div class="accordionData" :class="open ? 'open' : ''">
          <ul class="dataList">
            <li>
              <span>{{ $t('footer.ceo') }}</span>
              {{ $t('footer.ceo_names') }}
            </li>
            <li>
              <span>{{ $t('footer.address') }}</span>
              {{ $t('footer.address_details') }}
            </li>
            <li>
              <span>{{ $t('footer.business_registration_number') }}</span>
              {{ $t('footer.registration_number') }}
            </li>
            <li>
              <span>{{ $t('footer.ecommerce_registration_number') }}</span>
              {{ $t('footer.ecommerce_number') }}
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <nav class="navigationFooter">
      <ul class="policy">
        <li>
          <a :href="termsOfServiceUrl" target="_blank">
            {{ $t('footer.terms_of_service_A06') }}
          </a>
        </li>
        <li>
          <a :href="privacyPolicyUrl" target="_blank">
            <strong>{{ $t('footer.privacy_policy_A07') }}</strong>
          </a>
        </li>
      </ul>
    </nav>
    <div class="copyright">ⓒ NEXON Korea Corporation All Rights Reserved.</div>
  </footer>
</template>

<script>
import { getBaseInfo } from '@/utils'

export default {
  name: 'ShopFooter',
  data() {
    return {
      nationPath: 'kr',
      open: false
    }
  },
  computed: {
    privacyPolicyUrl() {
      return this.nationPath === 'kr'
        ? 'https://member.nexon.com/policy/privacy.aspx'
        : 'https://www.nexon.co.jp/privacypolicy/'
    },
    termsOfServiceUrl() {
      return this.nationPath === 'kr'
        ? 'https://member.nexon.com/policy/stipulation.aspx'
        : 'https://jp.nexon.com/rule/agreement.aspx'
    }
  },
  methods: {
    toggleAccordion() {
      this.open = !this.open
    }
  },
  mounted() {
    const { nationPath } = getBaseInfo()
    this.nationPath = nationPath
  }
}
</script>

<style lang="scss">
.footer {
  position: static;
  z-index: 999;

  // DO : 배송/펀딩상품 추가 - footer 스타일 수정
  max-width: 640px;
  margin: 0 auto 55px;
  font-family: 'Malgun Gothic', 'Nanum Gothic';
  text-align: center;
  //background-color: #f7f7f7;

  .companyInfo {
    display: block;
    max-width: 640px;
    margin: 0 auto;
  }
  .navigationFooter {
    max-width: 640px;
    margin: 0 auto;
    padding-top: 18px;

    .policy {
      display: block;
      padding: 2px 0;

      li {
        display: inline-block;
        margin: 0 3px;
        color: #d1d2d4;
        font-size: 11px;

        &:first-child::after {
          display: inline-block;
          content: '|';
          margin: -1px 0 0 6px;
          vertical-align: top;
        }
      }
    }
  }
  a {
    color: #555;
    font-size: 11px;
  }
  .copyright {
    padding-top: 5px;
    color: #777;
    font-size: 10px;
  }
}

// DO -> 결제하기 페이지 외에 모두 노출

.order + .footer {
  padding: 0;
  .companyInfo {
    display: none;
  }
  .navigationFooter {
    .policy {
      display: none;
    }
  }
}

.main + .footer,
.category + .footer {
  .navigationFooter {
    max-width: 100%;
  }
}
.footer {
  // safeArea
}
.order + .footer {
  // safeArea
}
.cart + .footer {
  // safeArea
}

@media all and (max-width: 640px) {
  .footer {
    .companyInfo {
      .accordionData {
        .dataList {
          width: auto;
        }
      }
    }
  }
}
</style>
